import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetFinixMerchantRequestSchema,
  TGetFinixMerchantResponseSchema,
} from "./getFinixMerchant.schema";

export const getFinixMerchant = (axios: IAxiosInstance) => {
  return async (params: TGetFinixMerchantRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetFinixMerchantResponseSchema>
    >(`/api/business-cards/merchant`, { params });

    return response.data;
  };
};
